import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import React from "react";
import { Row, Col, Avatar } from "antd";
import {
  FacebookFilled,
  TwitterSquareFilled,
  LinkedinFilled,
  LinkOutlined,
} from "@ant-design/icons";
import bannerImage3 from "../../assets/echoo.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";

const Trolling = () => {
  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          // style={{
          //   background: `url(${bannerImage3}) no-repeat center center/cover`,
          // }}
          style={{
            backgroundColor: "black",
          }}
        >
          <h1>Trolling: We Must Draw a Line</h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <Avatar size={64} src="https://thispersondoesnotexist.com/" />

                  <div className={styles.authorText}>
                    <h3>Harleen Cook</h3>
                    <p></p>
                  </div>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on May 29, 2025</p>
                <h1 className={styles.postTitle}>
                  Trolling: We Must Draw a Line
                </h1>
                <p className={styles.author}>By Harleen Cook</p>
              </div>
              <div className={styles.contents}>
                <h4>Contents</h4>
                <ul>
                  <li>
                    <a href="#letter">A letter from Harleen & Andrew</a>
                  </li>
                  <li>
                    <a href="#soften">
                      Trolling: A Word That Softens the Truth
                    </a>
                  </li>
                  <li>
                    <a href="#cruelty">
                      The Real-World Impact of Digital Cruelty
                    </a>
                  </li>
                  <li>
                    <a href="#rules">
                      We Have Rules—So Why Don’t They Apply Online?
                    </a>
                  </li>
                  <li>
                    <a href="#stories">
                      What Stories Teach Us About Courage and Voice
                    </a>
                  </li>
                  <li>
                    <a href="#platform">
                      {BRAND.domainLabel}: A Platform Where Cruelty Isn’t Welcome
                    </a>
                  </li>

                  <li>
                    <a href="#future">
                      A Path Forward—One Page, One Post, One Protected Voice at
                      a Time
                    </a>
                  </li>

                  <li>
                    <a href="#references">References</a>
                  </li>
                </ul>
              </div>

              <div className={styles.share}>
                <h4>Share This Blog</h4>
                <div className={styles.icons}>
                  <FacebookFilled />
                  <TwitterSquareFilled />
                  <LinkedinFilled />
                  <LinkOutlined />
                </div>
              </div>
            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p className={styles.intro} id="letter">
                <strong>
                  A letter from Harleen & Andrew, founders of The Buddyhood Ltd
                  and {BRAND.domainLabel}
                </strong>
              </p>
              <p className={styles.intro} id="letter">
                <em>
                  As parents, we have experienced the pain of hearing our
                  children come home and say that someone was unkind to them at
                  school when they did nothing wrong. As normal as this may
                  seem, it is a form of mild bullying, and when raised with the
                  teachers, action is taken and apologies are sought. From a
                  very young age, we encourage children to use their “kind
                  hands” and “kind words”. However, something changes as they
                  grow up. Online it is acceptable, if not almost desirable, to
                  use unkind words. Words that have the power to destroy even
                  the most stable of minds.
                </em>
              </p>

              <p>
                This is not a world that should be considered normal for anyone,
                let alone for our own children to grow up in. Why has it become
                acceptable?
              </p>
              <p>
                The very same actions that would be considered as anti-social,
                bullying, and at times criminal, are brushed off online as “just
                a comment,” “just a joke,” or worse—"free speech."
              </p>
              <p>
                When is a joke no longer a joke? When is it time to say enough?
              </p>

              {/* <img
                src="/Images/brainworks.png"
                alt="Brain in a cage"
                className={styles.featureImage}
              /> */}

              <h2 id="soften">Trolling: A Word That Softens the Truth</h2>
              <p>
                We've made it sound trivial. “Trolling” evokes images of
                pranksters under bridges. Mischief. Drama. Even humour.
              </p>
              <p>
                In reality, trolling is ugly. It is harassment. Bullying. Abuse.
                Targeted and persistent, it's meant to humiliate, isolate, and
                destroy confidence—if not people. If done in the real world, it
                could be illegal.
              </p>
              <p>
                Online anonymity doesn't make it less real. It just makes it
                easier to get away with.
              </p>
              <p>
                In the UK, we already have laws that criminalise harassment,
                hate speech, and incitement. Yet when these same offences occur
                on a screen, they’re often met with a shrug—by platforms, by
                society, even by law enforcement.
              </p>
              <p>Why?</p>

              <h2 id="cruelty">The Real-World Impact of Digital Cruelty</h2>
              <p>The damage is far from virtual.</p>
              <p>
                In 2020, British TV presenter Caroline Flack died by suicide
                after months of being hounded online, despite stepping back from
                the public eye. Her final words—“Be kind”—became a trending
                hashtag. However, the trolls didn’t stop.
              </p>
              <p>
                Teenagers, like Molly Russell, a 14-year-old from London, who
                took her own life after being exposed to a torrent of harmful
                content online. Her father now campaigns tirelessly for
                accountability and reform, stating:
              </p>

              <p>
                “There were no warning signs, because everything was happening
                behind a screen.”
              </p>
              <p>
                In both cases, real lives were lost. Not because of a single
                comment—but because of sustained digital violence, ignored by
                those with the power to intervene.
              </p>
              <p>
                Mental health services across the UK report record highs of
                anxiety, self-harm, and suicide ideation among youth. The NSPCC
                has called online abuse a “public health crisis” that’s not
                being treated with the urgency it demands.
              </p>

              <h2 id="rules">We Have Rules—So Why Don’t They Apply Online?</h2>
              <p>In the physical world:</p>
              <ul className={styles.references}>
                <li>
                  A stranger following you and yelling insults would be called
                  stalking.
                </li>
                <li>
                  Someone shouting racial abuse in a classroom would be
                  expelled.
                </li>
                <li>A person making death threats would be arrested.</li>
              </ul>
              <p>
                But online? These same behaviours are often met with platform
                warnings, account suspensions, or nothing at all.
              </p>
              <p>Instead of protection, victims are told to:</p>

              <ul className={styles.references}>
                <li>Mute.</li>
                <li>Block.</li>
                <li>Log off.</li>
              </ul>
              <p>
                We'd never tell a child to just “walk away” from school
                bullying. Why do we tell them that online?
              </p>
              <p>
                Trolling thrives because the internet has become the last place
                where cruelty is allowed to roam freely, protected by lax
                moderation, action being taken too late, and vague terms of
                service.
              </p>

              <h2 id="stories">
                What Stories Teach Us About Courage and Voice
              </h2>
              <p>
                Throughout history—and storytelling—bullies have always existed.
                So have those brave enough to stand up to them.
              </p>

              <p>
                In many of our favourite books and films, it's the quietest
                voices that grow loudest in the face of cruelty. Think of
                Hermione Granger using her intellect to fight bigotry at
                Hogwarts. Or Frodo, an underestimated hobbit, refusing to be
                ruled by fear. Even Katniss Everdeen, in The Hunger Games,
                becomes a symbol not by shouting—but by refusing to be silent.
              </p>
              <p>
                These stories matter. They show young readers how to face
                conflict with resilience, how to challenge injustice with
                intelligence, and how to hold onto their sense of self—when the
                world tries to take it.
              </p>
              <p>At The Buddyhood, this is exactly what we aim to explore.</p>

              <p>
                Our books give voice to characters navigating bullying,
                exclusion, and prejudice. They also show how empathy, community,
                and courage win—not through violence or revenge, but through
                self-respect and understanding.
              </p>
              <p>
                We're not interested in glorifying cruelty. We're interested in
                what comes after it: healing, growth, justice.
              </p>

              <h2 id="platform">
                {BRAND.domainLabel}: A Platform Where Cruelty Isn't Welcome
              </h2>
              <p>
                We created {BRAND.domainLabel} because we couldn’t find a space where
                young people could share openly without risk. Where they could
                be honest without being attacked. Where someone could explore
                who they are—without someone else tearing it down.
              </p>

              <p>So we built one.</p>

              <p>
                <strong>No comments.</strong>
              </p>
              <p>
                <strong>All content is pre-moderated for safety.</strong>
              </p>
              <p>
                <strong>
                  Reflections are tied to values—like life, safety and laughter.
                </strong>
              </p>
              <p>
                <strong>Verified users due to our subscription model.</strong>
              </p>
              <p>
                <strong>
                  Every voice is protected. Every user is respected. .
                </strong>
              </p>

              <p>
                If someone shares about their pain, no one will mock them. If
                someone shares a vulnerable thought, it won't be rated,
                dissected, or turned into content. If someone is cruel, action
                will be taken.
              </p>

              <p>
                This is how the real-world works. So, this is how our platform
                works.
              </p>

              <p>
                {BRAND.domainLabel} isn’t about being “positive” all the time. It’s
                about being real—but in a space where empathy outweighs ego.
              </p>

              <h2 id="future">
                A Path Forward—One Page, One Post, One Protected Voice at a Time
              </h2>
              <p>
                Let's build a world where saying “that hurt me” doesn't invite
                ridicule.
              </p>
              <p>
                Where digital courage is matched by digital safety. Where
                children know that if someone abuses them online, the adults
                will act—not just advise silence.
              </p>
              <p>
                Let's show young people that expressing pain is strength. That
                asking for help is power. That cruelty doesn’t deserve a
                stage—but kindness does.
              </p>
              <p>
                Let's change the way we respond to trolling—not just with tech,
                but with humanity.
              </p>

              <p>That's the power of boundaries.</p>
              <p>That's the power of stories.</p>
              <p>That's the power of you.</p>

              <p>
                <strong>— Harleen & Andrew</strong>
                <br />
                Founders of The Buddyhood Ltd and {BRAND.domainLabel}
              </p>
              <h3 id="references"> References</h3>
              <ul className={styles.references}>
                <li>
                  BBC News (2020). Caroline Flack: TV Presenter Took Her Own
                  Life
                </li>
                <li>
                  The Guardian (2022). Molly Russell Inquest: Instagram
                  Contributed to Death
                </li>
                <li>
                  NSPCC (2023). Online Abuse and Mental Health in Young People:
                  A Growing Crisis
                </li>
                <li>
                  Ofcom (2024). Online Safety and Regulation: Why UK Teens Feel
                  Unprotected
                </li>
                <li>
                  Children’s Commissioner for England (2023). Tackling Trolling
                  and Digital Harassment
                </li>
                <li>
                  Netflix: The Hunger Games, Harry Potter, The Lord of the Rings
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Trolling;
